import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/ui/back-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/ui/favourite.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/ui/games/game-image.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/placeholder.webp");
